import { render, staticRenderFns } from "./ChallengeOrganisation.vue?vue&type=template&id=554d2eda&"
import script from "./ChallengeOrganisation.vue?vue&type=script&lang=js&"
export * from "./ChallengeOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554d2eda')) {
      api.createRecord('554d2eda', component.options)
    } else {
      api.reload('554d2eda', component.options)
    }
    module.hot.accept("./ChallengeOrganisation.vue?vue&type=template&id=554d2eda&", function () {
      api.rerender('554d2eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ChallengeOrganisation.vue"
export default component.exports